export default __webpack_public_path__ + "static/media/0000..0004.1bfd9df2.png";